<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      title="Məhsul axtarışları"
      :main="$t('dashboardVue.dashboard')"
    />
    <!-- Container-fluid starts-->
    <div class="container mt-4">
      <!-- Basic Search -->
      <div class="row mb-3">
        <div class="col">
          <div class="input-group search-input-group">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control search-input"
              placeholder="Malın adı üzrə axtarış"
              @keyup.enter="searchProducts"
            >
            <button
              class="btn btn-primary search-button"
              @click="searchProducts"
            >
              <i class="fa fa-search" />
            </button>
          </div>
        </div>
      </div>

      <!-- Toggle Advanced Search -->
      <div class="row mb-3">
        <div class="col text-center">
          <button
            class="btn btn-secondary"
            @click="toggleAdvancedSearch"
          >
            {{ advancedSearchVisible ? 'Gizlətmək' : 'Ətraflı axtarış' }}
          </button>
        </div>
      </div>

      <!-- Advanced Search -->
      <div
        v-if="advancedSearchVisible"
        class="row mb-3"
      >
        <div class="col">
          <div class="input-group mb-3">
            <div class="mb-3">
              <label>{{ $t('companySearch.faliyytSahlri') }}</label>

              <div class="mt-1">
                <button
                  v-b-modal.modal-sector-selection
                  type="button"
                  class="btn btn-sm btn-light-primary"
                >
                  {{ $t('companyProfile.faliyytSahsiniSein') }}
                </button>
              </div>

              <hr v-if="selectedSectors.length > 0">
              <SelectedSectorView
                :sectors="selectedSectors"
                :parent-id="0"
              />
            </div>
          </div>
          <div
            v-for="option in filterOptions"
            :key="option.value"
            class="form-check form-check-lg"
          >
            <input
              :id="option.value"
              v-model="selectedFilters"
              class="form-check-input"
              type="checkbox"
              :value="option.value"
            >
            <label
              class="form-check-label"
              :for="option.value"
            >
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

      <!-- Search Results Message -->
      <div
        v-if="products.length && searchPerformed"
        class="row mb-3"
      >
        <div class="col">
          <h5>Axtarılan məhsul və xidmətlə əlaqədar nəticələr</h5>
        </div>
      </div>

      <!-- No Results Message -->
      <div
        v-if="!products.length && searchPerformed"
        class="row mb-3"
      >
        <div class="col text-center">
          <p>Axtarılan məhsul və xidmətlə əlaqədar nəticələr tapılmadı</p>
          <p>
            Axtardığınız məhsul və xidmət üçün satınalma sorğusu yaradın və bir başa aidiyyatı sektorun tədarükçülərinə
            göndərin. Hazırda bazada 3000-dən çox tədarükçü var. Sizin sorğunuza cavab vermək tədarükçülər üçün
            fürsətdir.
          </p>
          <button
            class="btn btn-primary"
            @click="createInquiry"
          >
            Sorğu yarat
          </button>
        </div>
      </div>

      <!-- Products Grid -->
      <div
        v-else
        class="row"
      >
        <div
          v-for="product in products"
          :key="product.id"
          class="col-md-3 mb-4"
        >
          <div
            class="card h-100"
            @click.prevent="openProductInNewTab(product.id)"
          >
            <img
              :src="mediaBase + product.coverPhotoUrl"
              class="card-img-top fixed-img-height"
              alt="Product"
            >
            <div class="card-body text-center">
              <h5 class="card-title">
                {{ product.name }}
              </h5>
              <p class="card-text">
                {{ product.company?.name || 'Unknown Company' }}
              </p>
              <span
                v-if="product.status === 'ACTIVE'"
                class="text-success"
              >✔</span>
              <span
                v-else
                class="text-danger"
              >!</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Inquiries Section -->
      <div class="row mb-3">
        <div class="col">
          <h5>Məhsul axtarışı üzrə sorğu və müraciətlərim</h5>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Sorğu Nömrəsi</th>
                <th>Məhsul adı</th>
                <th>Şirkətin adı</th>
                <th>Tarix</th>
                <th>Mesaj</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="inquiry in inquiries"
                :key="inquiry.id"
              >
                <td>
                  <p class="text-secondary">
                    {{ inquiry.id }}
                  </p>
                </td>
                <td>
                  <p class="text-secondary">
                    {{ inquiry.productName }}
                  </p>
                </td>
                <td>
                  <p class="text-secondary">
                    {{ inquiry.companyName }}
                  </p>
                </td>
                <td>
                  <p class="text-secondary">
                    {{ new Date(inquiry.inquiryTime).toLocaleDateString() }}
                  </p>
                </td>
                <td class="align-middle text-center">
                  <router-link
                    v-if="inquiry.conversationId > 0"
                    :to="`/dashboard/conversation/${inquiry.conversationId}?conversation_type=product`"
                    class="btn btn-primary w-100 text-white"
                  >
                    Go to message
                  </router-link>
                  <p
                    v-else
                    class="text-secondary mb-0"
                  >
                    Cavab verilməyib
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Container-fluid ends-->
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <SectorSelectionModal
        :min-selection="3"
        :max-selection="1000"
        :parent-sector="null"
        :selected="selectedSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {searchProduct} from "@/repositories/ProductDataRepository";
import {getInquiries} from "@/repositories/InquiryDataRepository"; // Import your getInquiries function
import SectorSelectionModal from "@/components/sector_selection_modal.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";

export default {
  components: {SelectedSectorView, SectorSelectionModal},
  data() {
    return {
      mediaBase: mediaBase,
      searchQuery: "",
      advancedSearchVisible: false,
      selectedFilters: [], // Changed from a single value to an array for checkboxes
      products: [],
      selectedSectors: [],
      inquiries: [], // Add inquiries data property
      filterOptions: [
        {label: "Mal və məhsul üzrə mənşə və ya orijinallıq sertifikatı olsun", value: "certificate"},
        {label: "Şirkətin Referans məktubları olsun", value: "reference"},
      ],
      searchPerformed: false // Track if a search has been performed
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
      userPackageStatus: (state) => state.auth.userPackageStatus,
      userPackage: (state) => state.auth.userPackage,
    }),
  },
  mounted() {
    this.fetchInquiries(); // Fetch inquiries when the component is mounted
  },
  methods: {
    sectorSelected(sectors) {
      this.selectedSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    toggleAdvancedSearch() {
      this.advancedSearchVisible = !this.advancedSearchVisible;
    },
    searchProducts() {
      if (!this.searchQuery) {
        alert("Axtarış sözünü əlavə edin.");
        return;
      }

      const wsIds = this.selectedSectors.map(sector => sector.id); // Use selected sectors as wsIds
      const hasCerts = this.selectedFilters.includes('certificate');
      const hasContracts = this.selectedFilters.includes('reference');

      try {
        searchProduct(this.token, this.searchQuery, wsIds, hasCerts, hasContracts).then(data => {
          this.searchPerformed = true; // Mark that a search has been performed
          if (data.code === 200) {
            this.products = data.products;
          } else {
            console.error(data.message);
            this.products = [];
          }
        })
      } catch (error) {
        console.error(error.message);
        this.products = [];
      }
    },
    fetchInquiries() {
      getInquiries(this.token).then((data) => {
        if (data.code === 200) {
          this.inquiries = data.inquiries;
        } else {
          console.error(data.message);
          this.inquiries = [];
        }
      });
    },
    openProductInNewTab(productId) {
      const url = this.$router.resolve({name: "product", params: {id: productId}}).href;
      window.open(url, "_blank");
    },
    createInquiry() {
      this.$bvModal.show("modal-request-create");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme/_variables.scss";

.product-search-card {
  border: 0.5px solid #000; /* Adjust the border thickness here */
}

.search-title {
  display: flex;
  align-items: center;
  justify-content: center; /* Center the content horizontally */
  width: 100%; /* Ensure the container takes the full width */
}

.search-icon {
  font-size: 24px; /* Adjust the icon size */
  margin-left: 10px; /* Space between icon and text */
}

.search-text {
  font-size: 24px; /* Adjust the text size */
  margin: 0; /* Remove margin from h1 */
}

/* Custom styles for larger search input and button */
.search-input-group .search-input {
  font-size: 18px;
  height: 50px;
}

.search-input-group .search-button {
  font-size: 18px;
  height: 50px;
  width: 60px; /* Adjust width to accommodate the icon */
}

/* Custom styles for larger checkboxes */
.form-check-lg .form-check-input {
  width: 24px;
  height: 24px;
}

.form-check-lg .form-check-label {
  font-size: 18px;
  margin-left: 8px; /* Adjust space between checkbox and label */
}

/* Ensure all product images have a fixed height */
.fixed-img-height {
  height: 200px; /* Adjust the height as necessary */
  object-fit: cover;
  width: 100%; /* Ensure the image takes up the full width of the container */
}
</style>
